/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 08:51:38
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-24 17:20:45
 */
/**
 * Dropdown Control Template
 * @param options array options DOM
 * @returns string
 */
export default (options: JQuery<HTMLOptionElement>): string => {
  let optionsTemplate = '';
  let selectedOption: JQuery = $([]);
  options.each(function (_index) {
    if ($(this).data('type') == 'group') {
      optionsTemplate += `<div class="gf-dropdown-label" data-value="${$(this).val()}"><p>${$(this).text()}</p></div>`;
    } else {
      optionsTemplate += `<div class="gf-dropdown-item ${
        $(this).is(':selected') ? 'gf-dropdown-item-selected' : ''
      }" data-key="${$(this).val()}" data-value="${$(this).val()}"><p>${$(this).text()}</p></div>`;
    }

    if (!(selectedOption && selectedOption.length) && $(this).is(':selected')) {
      selectedOption = $(this);
    }
  });

  if (!(selectedOption && selectedOption.length) && options && options.length) {
    selectedOption = $(options[0]);
  }

  let template = '';
  template += `
  <div class="gf-dropdown">
    <div class="gf-dropdown-selected">
      <p>${selectedOption.text()}</p>
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.469727 9.53039L1.53039 8.46973L4.00006 10.9394L6.46973 8.46973L7.53039 9.53039L4.00006 13.0607L0.469727 9.53039Z" fill="#D6D6D6"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.469727 4.46986L1.53039 5.53052L4.00006 3.06085L6.46973 5.53052L7.53039 4.46986L4.00006 0.939527L0.469727 4.46986Z" fill="#D6D6D6"/>
      </svg>
    </div>
    <div class="gf-dropdown-list">
      ${optionsTemplate}
    </div>
  </div>
  `;
  return template;
};
